export const ACTIONS = {
    SET_ANNOUNCER: 'SET_ANNOUNCER',
}

export const setAnnouncer = data => dispatch => {
    dispatch({ type: ACTIONS.SET_ANNOUNCER, data })
    setTimeout(() => {
        dispatch({ type: ACTIONS.SET_ANNOUNCER, data: '' })
    }, 1000)
}
